import { ComponentProps } from "solid-js"

/**
 * The Kettle mark boiling, then pouring: a strip of frames
 * (scripts/generate-spinner-frames.mjs) masking the text color, stepped one
 * frame at a time by a transform animation. That is one compositor animation
 * per spinner at 30 frames a second, with no painting. Animating the mark's
 * parts themselves would repaint every frame and add a compositor layer per
 * part, which every frame mounting transcript rows must re-layerize around.
 * An animated image would cost less but stays still when iOS's Auto-Play
 * Animated Images setting is off, and a spinner carries loading state.
 */
export function Spinner(props: {
  class?: string
  classList?: ComponentProps<"span">["classList"]
  style?: ComponentProps<"span">["style"]
}) {
  return (
    <span
      {...props}
      data-component="spinner"
      aria-hidden="true"
      classList={{
        ...(props.classList ?? {}),
        [props.class ?? ""]: !!props.class,
      }}
    >
      <span data-slot="spinner-frames" />
    </span>
  )
}
